
export class FormChat {
    id: number;
    data_json: any;
    chat_id: number;

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.data_json = JSON.parse(apiModel.data_json);
        this.chat_id = apiModel.chat_id;
        return this;
    }
}
